/* ai-base.js : the only behaviours the replicas share. Everything else is section-scoped. */
(function () {
  var on = function (ev, sel, fn) { document.addEventListener(ev, function (e) { var t = e.target.closest(sel); if (t) fn(e, t); }); };
  /* drawers, menus, search panels:  <button data-ai-toggle="#target">  toggles .is-open on the target */
  on('click', '[data-ai-toggle]', function (e, btn) {
    var t = document.querySelector(btn.getAttribute('data-ai-toggle')); if (!t) return;
    var open = t.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open); document.documentElement.classList.toggle('ai-lock', open && t.hasAttribute('data-ai-lock'));
  });
  on('click', '[data-ai-close]', function (e, el) { var t = el.closest('.is-open'); if (t) { t.classList.remove('is-open'); document.documentElement.classList.remove('ai-lock'); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.querySelectorAll('.is-open').forEach(function (n) { n.classList.remove('is-open'); }); });
  /* sliders:  [data-ai-slider] > [data-ai-track] , buttons [data-ai-prev] [data-ai-next] */
  on('click', '[data-ai-prev],[data-ai-next]', function (e, b) {
    var s = b.closest('[data-ai-slider]'), tr = s && s.querySelector('[data-ai-track]'); if (!tr) return;
    tr.scrollBy({ left: (b.hasAttribute('data-ai-next') ? 1 : -1) * tr.clientWidth * 0.9, behavior: 'smooth' });
  });
  /* sticky header state:  [data-ai-sticky] gets .is-stuck after the first scroll */
  var st = document.querySelectorAll('[data-ai-sticky]');
  if (st.length) addEventListener('scroll', function () { st.forEach(function (n) { n.classList.toggle('is-stuck', scrollY > 10); }); }, { passive: true });
})();
